import { render, staticRenderFns } from "./DerbyLink.vue?vue&type=template&id=6acef40d&"
import script from "./DerbyLink.vue?vue&type=script&lang=js&"
export * from "./DerbyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports